import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, firstValueFrom, from, lastValueFrom, map, switchMap, take } from "rxjs";
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { BusinessIdService } from 'src/libs/shared-services/businessid.service';
import { GlobalState } from 'src/app/global.state';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(public afAuth: AngularFireAuth, public globalStateService: GlobalState) {}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    return from(this.handle(request, next))
  }

  async handle(request: HttpRequest<any>, next: HttpHandler) {

    let headers : any = {};

    const currentUser = await this.afAuth.currentUser;

    // must check for current users for cases like:
    // - setup new account where not user is logged in and we make an api call
    // - invoice link pages with passwords
    if(currentUser){
      // Returns the current token if it has not expired. Otherwise, this will refresh the token and return a new one.
      const tokenFound = await currentUser!.getIdToken(false);
  
      headers = {
        Authorization: `Bearer ${tokenFound}`
      }
    }
    
    const idToEmulate = sessionStorage.getItem("user-to-emulate")
    if(idToEmulate)
    {
      headers.UserToEmulate = idToEmulate;
    }

    // we can't look for the current business id when we are trying to get the business ids :)
    if(currentUser && !request.url.includes("GetUserBusinesses"))
    {
      // if no business found, this will just be set to ""
      headers.BusinessId = await this.globalStateService.getCurrentBusinessId();
    }

    if(environment.production === true)
    {
      headers.prod = "true";
    }

    request = request.clone({
      setHeaders: headers
    });

    return await lastValueFrom(next.handle(request));
  }
}